/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateNftGroupingBody
 */
export interface UpdateNftGroupingBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    groupingId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateNftGroupingBody
     */
    sortPriority?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    discordUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    twitterUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    websiteUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    hero?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    icon?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateNftGroupingBody
     */
    categories?: Array<string>;
}

/**
 * Check if a given object implements the UpdateNftGroupingBody interface.
 */
export function instanceOfUpdateNftGroupingBody(value: object): value is UpdateNftGroupingBody {
    if (!('groupingId' in value) || value['groupingId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpdateNftGroupingBodyFromJSON(json: any): UpdateNftGroupingBody {
    return UpdateNftGroupingBodyFromJSONTyped(json, false);
}

export function UpdateNftGroupingBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNftGroupingBody {
    if (json == null) {
        return json;
    }
    return {
        
        'groupingId': json['groupingId'],
        'name': json['name'],
        'sortPriority': json['sortPriority'] == null ? undefined : json['sortPriority'],
        'description': json['description'] == null ? undefined : json['description'],
        'discordUrl': json['discordUrl'] == null ? undefined : json['discordUrl'],
        'twitterUrl': json['twitterUrl'] == null ? undefined : json['twitterUrl'],
        'websiteUrl': json['websiteUrl'] == null ? undefined : json['websiteUrl'],
        'hero': json['hero'] == null ? undefined : json['hero'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'categories': json['categories'] == null ? undefined : json['categories'],
    };
}

export function UpdateNftGroupingBodyToJSON(json: any): UpdateNftGroupingBody {
    return UpdateNftGroupingBodyToJSONTyped(json, false);
}

export function UpdateNftGroupingBodyToJSONTyped(value?: UpdateNftGroupingBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groupingId': value['groupingId'],
        'name': value['name'],
        'sortPriority': value['sortPriority'],
        'description': value['description'],
        'discordUrl': value['discordUrl'],
        'twitterUrl': value['twitterUrl'],
        'websiteUrl': value['websiteUrl'],
        'hero': value['hero'],
        'icon': value['icon'],
        'categories': value['categories'],
    };
}

